var data = { header:{ text:"#### Additional genes required",
    closeButton:true },
  body:{ text:"At this time, you cannot order FMR1 as an individual gene, it must be ordered with another carrier gene. Please\ninclude at least one other gene with your FMR1 order." },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=carrier_fmr1_only_error.esm.js.map
